<template>
    <div
        v-if="slides.length"
        id="cz2__banner-ad--wrapper"
        :class="{ 'extra-padding': extraPadding }"
        class="cz2__banner-ad--wrapper"
    >
        <custom-swiper
            :autoHeight="true"
            :autoPlay="true"
            :showMask="false"
            :spaceBetween="0"
            :allowSticky="true"
        >
            <template v-slot:slides>
                <a
                    v-for="slide in slides"
                    :key="slide.desktopImg"
                    :href="slide.url"
                    :class="{ 'has-link': slide.url }"
                    class="swiper-slide"
                >
                    <picture>
                        <source
                            media="(min-width:768px)"
                            :srcset="slide.desktopImg"
                        />
                        <img
                            :src="slide.mobileImg"
                            :alt="slide.altText"
                        />
                    </picture>
                </a>
            </template>
        </custom-swiper>
    </div>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__banner-ad--wrapper {
            width: 100%;
            max-width: 968px;
            margin: 30px auto;

            @media (max-width: 1024px) {
                padding: 0 32px;
            }

            .swiper-container-outer {
                margin: 0;
                padding: 0;
                width: 100%;
            }

            .swiper-container {
                padding: 0;
            }

            .swiper-slide {
                aspect-ratio: 676/570;
                border-radius: 48px;
                overflow: hidden;

                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    transition: transform 0.3s ease-in-out;
                }

                &.has-link {
                    &:focus-visible,
                    &:hover {
                        border: 3px solid #1E5A99;

                        img {
                            transform: scale(1.02);
                        }
                    }
                }
            }

            .swiper-custom-arrow {
                background-color: #EDEDED;

                &.swiper-custom-arrow--left {
                    transform: rotate(-180deg);
                }

                &.swiper-custom-arrow--right {
                    transform: rotate(360deg);
                }
            }

            .swiper-custom-bullets {
                gap: 8px;
            }

            .swiper-custom-bullets__bullet {
                width: 8px;
                height: 8px;

                &::after {
                    top: 0;
                    left: 0;
                    width: 9px;
                    height: 9px;
                    background: #D6D6D6;
                }

                &.swiper-custom-bullets__bullet--active {
                    &::before {
                        display: none;
                    }
                    &::after {
                        background: black;
                    }
                }
            }

            @include respond-below(md) {
                .swiper-custom-arrow {
                    top: calc(100% + 4px);
                }
            }

            @include respond-above(md) {
                width: calc(100% - 100px);

                .swiper-custom-arrow,
                .swiper-custom-arrow.has-mobile-bullets {
                    &.swiper-custom-arrow--left {
                        right: calc(100% + 8px);
                    }

                    &.swiper-custom-arrow--right {
                        left: calc(100% + 8px);
                    }
                }

                .swiper-slide {
                    aspect-ratio: 24/5;
                }
            }

            @include respond-above(xl) {
                width: 100%;

                .swiper-custom-arrow,
                .swiper-custom-arrow.has-mobile-bullets {
                    &.swiper-custom-arrow--left {
                        right: calc(100% + 50px);
                    }

                    &.swiper-custom-arrow--right {
                        left: calc(100% + 50px);
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__banner-ad--wrapper {
            margin: 98px 0;

            &.extra-padding {
                margin: 64px 0 192px 0;
            }
        }
    }
</style>

<script>
    import CustomSwiper from './ui/CustomSwiper.vue';

    export default {
        components: {
            CustomSwiper,
        },

        data() {
            return {
                slides: [],
            };
        },

        props: {
            extraPadding: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },
        },

        mounted() {
            if (this.globalSettings) {
                this.getSlides();
            }
        },

        methods: {
            getSlides() {
                for (let i = 1; i <= 5; i += 1) {
                    const desktopImage = this.globalSettings[`banner-ad-${i}`];
                    const mobileImage = this.globalSettings[`banner-ad-${i}-mobile`];
                    const altText = this.globalSettings[`banner-ad-${i}-alt`];
                    const url = this.globalSettings[`banner-ad-${i}-url`];

                    if (desktopImage && mobileImage) {
                        this.slides.push({
                            desktopImg: desktopImage,
                            mobileImg: mobileImage,
                            altText,
                            url,
                        });
                    }
                }
            },
        },
    };
</script>
